import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// env
import { environment } from './../../../../environments/environment';

// Service
import { ApiService } from '../../../shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';

@Component({
  selector: 'app-subsidiaries',
  templateUrl: './subsidiaries.component.html',
  styles: [
  ]
})
export class SubsidiariesComponent implements OnInit {
  
  dataTitle;
  dataSection = [];
  apiAsset = environment.API_ASSETS;

  constructor(private apiService: ApiService, 
              private globalService: GlobalService,
              private router: Router) {
    this.globalService.isLoading.next(true);
  }

  ngOnInit(): void {
    // Content
    this.apiService.getDataApi('getMenuSection/group-structure-subsidiaries').subscribe(response => {
      if(response.success) {
        this.dataTitle = response.data;
        this.dataSection = response.data.section;
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
        this.globalService.isLoading.next(false);
      } else {
        this.router.navigate(['/not-found']);
      }
    });
  }

}
